import React, { useEffect, useMemo } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import { STORE_MENU_DATA } from '@magento/venia-ui/lib/components/Header/headerNavigation.gql';
import { ROOT_CAT_LIST } from '@magento/venia-ui/lib/components/CategoryList/categoryList.gql';
import CmsBlockGroup from "@magento/venia-ui/lib/components/CmsBlock";
import mergeOperations from '../../util/shallowMerge';
import parseMenuNodes from '../Header/parseMenuNodes';
import { useStoreSwitcher } from '../Header/useStoreSwitcher';
import DEFAULT_OPERATIONS from './footer.gql';
import { GET_WISHLIST_CONFIG } from '../ProductFullDetail/productFullDetail.gql';

/**
 *
 * @param {*} props.operations GraphQL operations used by talons
 */
export var useFooter = function () {
  var _catData$category;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  var {
    getCopyrightQuery
  } = operations;
  var {
    data: dataConfig
  } = useQuery(getCopyrightQuery, {
    fetchPolicy: 'cache-and-network'
  });
  var {
    data: storeConfigData
  } = useQuery(GET_WISHLIST_CONFIG, {
    fetchPolicy: 'cache-and-network'
  });
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var [loadMenuHeader, {
    data: menuData,
    loading: menuLoading,
    error: menuError
  }] = useLazyQuery(STORE_MENU_DATA, {
    fetchPolicy: 'cache-and-network',
    variables: {
      identifier: 'footer_menu',
      activeStoreCode: currentStoreCode
    }
  });
  var menuFooter = useMemo(() => {
    if (!menuData && !menuLoading && !menuError) {
      loadMenuHeader();
    } else if (menuData && menuData.storeMenuByIdentifier && menuData.storeMenuByIdentifier.items) {
      var menuNodes = [];
      if (menuData.storeMenuByIdentifier.items.length > 0) {
        menuNodes = parseMenuNodes(menuData.storeMenuByIdentifier.items[0].nodes, true);
      }
      return menuNodes;
    } else if (menuError) {
      console.error(menuError);
    }
    return null;
  }, [menuData, menuLoading, menuError, loadMenuHeader]);
  var [loadRootCat, {
    data: catData
  }] = useLazyQuery(ROOT_CAT_LIST);
  useEffect(() => {
    if (!catData && dataConfig) {
      loadRootCat({
        fetchPolicy: 'cache-and-network',
        variables: {
          id: dataConfig.storeConfig.root_category_id
        }
      });
    }
  }, [catData, dataConfig]);
  var blockSocialMedia = /*#__PURE__*/React.createElement(CmsBlockGroup, {
    identifiers: ['social-media']
  });
  var catDataRoot = (catData === null || catData === void 0 || (_catData$category = catData.category) === null || _catData$category === void 0 ? void 0 : _catData$category.children) || [];
  return {
    copyrightText: dataConfig && dataConfig.storeConfig && dataConfig.storeConfig.root_category_id,
    menuFooter,
    pageSize: dataConfig && dataConfig.storeConfig && Number(dataConfig.storeConfig.grid_per_page),
    catDataRoot,
    storeConfig: storeConfigData,
    blockSocialMedia
  };
};